import * as React from 'react';

export interface UseBhanzuBuddySwitchToGuideProps {
  setCurrentMode: (mode: 'explain' | 'guide') => void;
  setCurrentSource: (source: string) => void;
}

export const useBhanzuBuddySwitchToGuide = ({
  setCurrentMode,
  setCurrentSource,
}: UseBhanzuBuddySwitchToGuideProps) => {
  const pendingGuideQuestionRef = React.useRef<string>('');

  const handleSwitchToGuide = React.useCallback(
    (lastQuestion: string) => {
      pendingGuideQuestionRef.current = lastQuestion;
      setCurrentMode('guide');
      setCurrentSource('guide_me');
    },
    [setCurrentMode, setCurrentSource]
  );

  return {
    pendingGuideQuestionRef,
    handleSwitchToGuide,
  };
};
